import styled from '~/app/components/styled'
import { Typography } from '@yanolja-org/ya-com-core'

export const ButtonContainer = styled.div`
  display: flex;
  padding: 1.2rem 2rem;
  margin-top: 1rem;

  & > *:first-of-type {
    margin-right: 0.8rem;
  }
`
export const CategoryOrderIdContainer = styled.div`
  background: ${({ theme }) => theme.color.gray50};
  padding: 1.6rem;
  ${Typography('body2').regular};
  color: ${({ theme }) => theme.color.gray900};
  text-align: center;
  margin: -1rem -1rem 1.2rem -1rem;
  > div:not(:first-of-type) {
    margin-top: 10px;
  }
`
